export default "__VITE_PUBLIC_ASSET__ee9f5d4f__"